import { DateTimeHelper } from "src/app/core/helper/datetime.helper";

export class Bid {
    bidId: number;
    productId: number;
    amount: string;
    value = 0;
    userId: number;
    displayName: string;
    email: string;
    phone: string;
    firstName: string;
    lastName: string;
    auctionEnd: string; // Used for auction extensions
    itemEnd: string; // Used for auction extensions
    maxBid = 0; // Used for max bids
    placed: string;
    itemStatus = 0;
    purchaseGuid: string;

    autoBids: Bid[] = [];

    placedString: string;

    public constructor(bid?: Partial<Bid>) {
        Object.assign(this, bid);
        
        this.autoBids = this.autoBids.map(m => new Bid(m));

        if (this.placed != null && !this.placed.endsWith('Z')) {
            this.placed = this.placed + 'Z';
        }
        this.placedString = DateTimeHelper.formatDate(this.placed, false, true);

        if (this.auctionEnd != null && !this.auctionEnd.endsWith('Z')) {
            this.auctionEnd = this.auctionEnd + 'Z';
        }

        if (this.itemEnd != null && !this.itemEnd.endsWith('Z')) {
            this.itemEnd = this.itemEnd + 'Z';
        }
    }
    
    get paidFor() { return (this.itemStatus & 1) === 1; }
    get pickedUp() { return (this.itemStatus & 2) === 2; }

}
